import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useEffect, useState, useRef, useCallback } from 'react';

function isMutableRef(ref) {
  return typeof ref !== 'function' && !!(ref !== null && ref !== void 0 && ref.current);
}

const getSelectedIndex = (option, StateManagerRef) => {
  let index = -1;

  if (StateManagerRef && StateManagerRef.current) {
    const {
      current: {
        select
      }
    } = StateManagerRef;

    if (option) {
      var _select$props$options;

      index = (_select$props$options = select.props.options) === null || _select$props$options === void 0 ? void 0 : _select$props$options.indexOf(option);
    }
  }

  return index;
};

export const SuggestBoxContext = /*#__PURE__*/createContext({
  selectedRowIndex: -1
});
export const SuggestProvider = ({
  children,
  changeHandler,
  selectRef,
  updateOnChangeHandler
}) => {
  const currentChangeHandler = useRef(null);
  const [StateManagerRef, setSelectStateManagerRef] = useState(isMutableRef(selectRef) ? selectRef : null);
  const [MenuListInstance, setMenuListInstance] = useState(null);
  const [selectedVal, setSelectedVal] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const [rowHeight, setRowHeight] = useState(25);
  useEffect(() => {
    const selectedIndex = getSelectedIndex(selectedVal, StateManagerRef);

    if (selectedIndex !== selectedRowIndex) {
      // No idea how to meet this condition in testing.

      /* istanbul ignore else */
      if (selectedIndex > -1 && MenuListInstance !== null) {
        MenuListInstance.scrollToRow(selectedIndex);
      }

      setSelectedRowIndex(selectedRowIndex);
    }
  }, [selectedRowIndex, selectedVal, StateManagerRef, MenuListInstance]);
  useEffect(() => {
    if (changeHandler !== currentChangeHandler.current) {
      updateOnChangeHandler(() => {
        const newHandler = _objectSpread({}, changeHandler);

        const originalOnChange = newHandler.onChange;

        newHandler.onChange = function onChange(val, action) {
          setSelectedVal(val);
          return originalOnChange(val, action);
        };

        currentChangeHandler.current = newHandler;
        return newHandler;
      });
    }
  }, [changeHandler, updateOnChangeHandler]);
  const getFocusedIndex = useCallback(() => {
    let index;

    if (StateManagerRef && StateManagerRef.current) {
      const {
        current: {
          select
        }
      } = StateManagerRef;
      const {
        focusedOption
      } = select.state;

      if (focusedOption) {
        var _select$props$options2;

        index = (_select$props$options2 = select.props.options) === null || _select$props$options2 === void 0 ? void 0 : _select$props$options2.indexOf(focusedOption);
      }
    }

    return index;
  }, [StateManagerRef]);
  const setMenuListRef = useCallback(node => {
    // No idea how to meet this condition in testing.

    /* istanbul ignore else */
    if (isMutableRef(selectRef) && selectRef.current !== StateManagerRef) {
      setSelectStateManagerRef(selectRef);
    }

    if (node.current !== MenuListInstance) {
      setMenuListInstance(node.current);
    }
  }, [selectRef, StateManagerRef, MenuListInstance]);
  return /*#__PURE__*/React.createElement(SuggestBoxContext.Provider, {
    value: {
      getFocusedIndex,
      setMenuListRef,
      setRowHeight,
      rowHeight,
      selectedRowIndex
    }
  }, children);
};